import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { type Post } from '@src/services/interface';

type PreTextProps = {
    content: {
        hasContent: Post['hasContent'];
        text?: string;
    };
};

const PreText = ({ content }: PreTextProps) => {
    const text = content?.text || '&nbsp;';

    return content.hasContent ? (
        <div className={styles.preText} dangerouslySetInnerHTML={{ __html: text.replace(/\n/g, '<br />') }} />
    ) : null;
};

export default errorBoundary(PreText);
